import { render, staticRenderFns } from "./adf-copy-note.vue?vue&type=template&id=6995e850&scoped=true&"
import script from "./adf-copy-note.vue?vue&type=script&lang=js&"
export * from "./adf-copy-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995e850",
  null
  
)

export default component.exports